import type { ReportRecordValue } from 'client/js/main/types/analytics';
import { format, parse } from 'date-fns';

export const dayFormatter = (value: ReportRecordValue) => {
  if (typeof value !== 'string') {
    return value;
  }

  const date = parse(value, 'yyyy-MM-dd', new Date());

  return format(date, 'yyyy/MM/dd');
};
